import Vue from 'vue'
import Vuex from 'vuex'
import GDPRControlAxios from './commons/gdprcontrol-axios'
import VueAxios from 'vue-axios'
import App from './App'
import store from './store/store'
import router from './commons/router'
import FormFields from './plugins/formFields'
import BootstrapVue from 'bootstrap-vue'
import VCalendar from 'v-calendar'
import 'v-calendar/lib/v-calendar.min.css'

import Notifications from 'vue-notification'

import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

import moment from 'moment'

// Bootstrap
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'font-awesome/css/font-awesome.min.css'

const vCalendarConfig = {
  firstDayOfWeek: 2,
  locale: 'hu',
  formats: {
    title: 'MMMM YYYY',
    weekdays: 'W',
    navMonths: 'MMM',
    input: ['YYYY-MM-DD'],
    dayPopover: 'L'
  }
}

Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(VueAxios, GDPRControlAxios)
Vue.use(FormFields)
Vue.use(BootstrapVue)
Vue.use(VCalendar, vCalendarConfig)
Vue.use(Notifications)

Vue.component('multiselect', Multiselect)

moment.locale('hu')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js